import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getEquipmentPhotos: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTOS,
	},
	getEquipmentPhoto: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTO,
	},
	createEquipmentPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].CREATE_PHOTO,
	},
	putEquipmentPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PUT_PHOTO,
	},
	patchEquipmentPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PATCH_PHOTO,
	},
	deleteEquipmentPhoto: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].DELETE_PHOTO,
	},
}
